import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { Loader } from "../../shared/uikit/Loader";
import supportUser1 from "../assets/icons/support-user-1.png";
import supportUser2 from "../assets/icons/support-user-2.png";
import supportUser3 from "../assets/icons/support-user-3.png";
import supportUser4 from "../assets/icons/support-user-4.png";
import supportUser5 from "../assets/icons/support-user-5.png";
import supportUser6 from "../assets/icons/support-user-6.png";
import supportUser7 from "../assets/icons/support-user-7.png";
import supportUser8 from "../assets/icons/support-user-8.png";

interface QueueBannerProps {
  queuePosition: number | null;
}

const supportUserImages = [
  supportUser1,
  supportUser2,
  supportUser3,
  supportUser4,
  supportUser5,
  supportUser6,
  supportUser7,
  supportUser8,
];

export const QueueBanner = ({ queuePosition }: QueueBannerProps) => {
  const userCount = queuePosition === 1 ? 1 : 2;
  const randomImages = supportUserImages
    .sort(() => Math.random() - 0.5)
    .slice(0, userCount);

  const mockUsers = randomImages.map((avatarUrl, i) => ({
    id: i + 1,
    name: `User ${i + 1}`,
    avatarUrl,
  }));

  const queueMessage =
    queuePosition === 1
      ? t("help_widget.queue_banner.next_in_line")
      : t("help_widget.queue_banner.people_ahead", { count: queuePosition });

  return (
    <div className="bg-primary border-primary mx-4 flex items-center gap-2 rounded-2xl border px-4 py-2">
      <div className="flex -space-x-3">
        {mockUsers.map(user => (
          <div key={user.id} className="rounded-full border-2 border-white">
            <UserImage
              hasBorder
              isFullRounded
              src={user.avatarUrl}
              size="6"
              name={user.name}
            />
          </div>
        ))}
      </div>

      <div className="flex flex-1 flex-col">
        <Typography.LabelSm weight="semibold" color="text-darkest">
          {queueMessage}
        </Typography.LabelSm>

        <Typography.LabelXs color="text-tertiary">
          {t("help_widget.queue_banner.wait_message")}
        </Typography.LabelXs>
      </div>
      <div className="shrink-0">
        <Loader className="!p-0" />
      </div>
    </div>
  );
};
